// ClientRoutes
import UserProfileStore from './UserProfileStore';

/* eslint-disable no-undef */

/* Pricing Service */
var io = require('socket.io-client');
var socket = null;


// Returns the socket
function getSocket() {

    if(socket === null) {
        
        socket = configureSocket();

        return socket;

    }
    else {
        return socket;
    }

}

// Connects socket to server and validates with user info
function configureSocket() {

    //var sock = io.connect('ws://ec2-34-210-220-99.us-west-2.compute.amazonaws.com:2000/');
    var sock = io.connect('https://localhost:2001/');

    // validate
    var userId = UserProfileStore.getUser();
    if(userId === null)
        userId = 'unknown machine';

    sock.on('connect', function() {
        console.log('SocketStore has connected to server sockets!');
        sock.emit('validate', userId);
    });

    return sock;

}

// Closes the current socket
function closeSocket() {

    socket.disconnect();
    socket = null;

}

const SocketStore = { getSocket, closeSocket };
export default SocketStore;






// WEBPACK FOOTER //
// ./src/Stores/SocketStore.js